import { CSSProperties } from "react";

export const styles: { [key: string]: CSSProperties } = {
  legend: {
    paddingBottom: 10,
  },
  nodata: {
    textAlign: "center",
    padding: 2,
  },
  tooltip: {
    color: "#000",
  },
};
